import { tenantQueryKey } from '../tenancy/queryKeys';

export const sitePublishingKeys = {
  all: ['site-publishing'] as const,
  tenant: (tenantId: string) => tenantQueryKey('site-publishing', tenantId),
  draft: (tenantId: string) => tenantQueryKey('site-publishing', tenantId, 'draft'),
  status: (tenantId: string) => tenantQueryKey('site-publishing', tenantId, 'status'),
  onboarding: (tenantId: string) => tenantQueryKey('site-publishing', tenantId, 'onboarding'),
};
